import { GET_GROUP_DETIALS_BY_ID_SUCCESS, GET_GROUP_DETAILS_BY_ID_FAILURE } from '../constants/MTag';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_GROUP_DETIALS_BY_ID_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
			};
		case GET_GROUP_DETAILS_BY_ID_FAILURE:
			return {
				...state,
				isLoading: false,
				errorData: action.payload,
				error: true,
			};
		default:
			return { ...state };
	}
};
